import { IUser } from "@features/users/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../types/auth.slice.types";

const initialState: AuthState = {
    token: null,
    user: null,
    isAuthInitialized: false,

};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        authTokenChange: (
            state,
            action: PayloadAction<{ accessToken: string }>
        ) => {
            state.token = action.payload.accessToken;
            state.isAuthInitialized = true;

        },
        logoutUser: (state) => {
            state.token = null;
            state.user = null;
            state.isAuthInitialized = false;

        },
        adjustUsedToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;
        },
        setUser: (state, action: PayloadAction<IUser | null>) => {
            state.user = action.payload;
            if (action.payload) {
                state.isAuthInitialized = true;
            }
        },
    },
});

export const { authTokenChange, logoutUser, adjustUsedToken, setUser } = authSlice.actions;

export default authSlice.reducer;
